export class MenuSelector {
  constructor(menuScrollBehavior) {
    this.menus = document.querySelectorAll('.menu-syndicated');
    this.itemActiveClass = 'menu-syndicated__body-item--active';
    this.menuScrollBehavior = menuScrollBehavior;
  }

  init = () => {
    if (this.menus.length > 0) {
      this.menus.forEach((menu) => this.prepareMenu(menu));
    }
  };

  prepareMenu = (menu) => {
    const select = menu.querySelector('[data-menu-select]');

    select.addEventListener('change', () => {
      this.changeMenu(select, menu);
    });
  };

  changeMenu = (select, menu) => {
    const activeItem = menu.querySelector(`.${this.itemActiveClass}`);
    if (activeItem) {
      activeItem.classList.remove(this.itemActiveClass);
    }

    const newActiveItem = menu.querySelector(`[data-menu-item="${select.value}"]`);
    if (newActiveItem) {
      newActiveItem.classList.add(this.itemActiveClass);
      this.menuScrollBehavior.defineActiveMenu();
    }
  };
}
